import { render, staticRenderFns } from "./recordsCount.vue?vue&type=template&id=208c9642&"
import script from "./recordsCount.vue?vue&type=script&lang=js&"
export * from "./recordsCount.vue?vue&type=script&lang=js&"
import style0 from "./recordsCount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports